export default "__VITE_ASSET__77029148__"